import { apiGet, apiPost, apiPut, apiDelete } from "../client";
import type {
	CreateRoleRequestApi,
	RolesResponseApi,
	RoleWithPermissionsResponseApi,
	UpdateRolePermissionsRequestApi,
} from "../models/role";

export async function getRoles(): Promise<RolesResponseApi> {
	return apiGet<RolesResponseApi>("system/roles");
}

export async function getRoleWithPermissions(
	roleId: number,
): Promise<RoleWithPermissionsResponseApi> {
	return apiGet<RoleWithPermissionsResponseApi>(
		`system/roles/${roleId}/permissions`,
	);
}

export async function createRole(
	request: CreateRoleRequestApi,
): Promise<RoleWithPermissionsResponseApi> {
	return apiPost<RoleWithPermissionsResponseApi>("system/roles", request);
}

export async function updateRole(
	roleId: number,
	request: UpdateRolePermissionsRequestApi,
): Promise<RoleWithPermissionsResponseApi> {
	return apiPut<RoleWithPermissionsResponseApi>(
		`system/roles/${roleId}`,
		request,
	);
}

export async function deleteRole(roleId: number): Promise<void> {
	return apiDelete<void>(`system/roles/${roleId}`);
}
